<template>
  <div v-html="texto" />
</template>
<script>
import excertoService from "@/service/ExcertoService";
export default {
  data() {
    return {
      deliberacao: {},
      texto: "",
    };
  },
  methods: {},
  created() {
    excertoService.buscarDeliberacao(this.$route.params.id).then((result) => {
      if (!result) {
        // id inexistente ou API indisponível: o service devolve undefined
        this.$router.push("/notfound");
        return;
      }
      this.deliberacao = result;
      if (this.deliberacao.textoDecisao) {
        this.texto = this.deliberacao.textoDecisao;
      }
    }).catch(err => {console.log(err), this.$router.push("/notfound")});
  },
};
</script>

<style>
</style>